import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';

// function CelebrateTemplateCard(props) {
//   return (
//     <div className="flex flex-row flex-nowrap rounded-[8px] cursor-pointer border-none shadow-md hover:bg-[#f2f2f2]">
//       <CardMedia
//         component="img"
//         sx={{ width: 160 }}
//         image={props.template.post_bg_resource_url}
//         alt="celebration image"
//       />
//       <Stack>
//         <CardContent>
//           <Typography gutterBottom variant="subtitle2" component="div">
//             {props.template.name}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {props.template.default_message}
//           </Typography>
//         </CardContent>
//       </Stack>
//     </div>
//   );
// }

// export default CelebrateTemplateCard;
// import { lazy, Suspense } from 'react';

// If using Next.js or a similar framework, use its built-in Image component for better optimization
// import Image from 'next/image';

function FundraiseTemplateCard(props) {
  return (
    <div className="flex cursor-pointer flex-row flex-nowrap rounded-[8px] border-b-2 hover:bg-[#f2f2f2]">
      <Stack>
        <CardContent>
          <Typography gutterBottom variant="subtitle2" component="div">
            {props.template.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.template.default_message}
          </Typography>
        </CardContent>
      </Stack>
    </div>
  );
}

export default FundraiseTemplateCard;
